// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__6eo3H","fileBtn":"File_fileBtn__3VPk6","closeBtn":"File_closeBtn__3dEVM","fileSelected":"File_fileSelected__3OtjI","disabled":"File_disabled__1b5i1"};